import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LocationSummaryBarProps {
  greenhouseCount: number;
  blockCount: number;
  totalAreaHa: number;
}

/**
 * Gradient pill summarizing the current Ubicación selection — pinned just
 * above the wizard sticky footer in step 2.
 */
export function LocationSummaryBar({
  greenhouseCount,
  blockCount,
  totalAreaHa,
}: LocationSummaryBarProps) {
  const { t } = useTranslation();
  const ghLabel =
    greenhouseCount === 1
      ? t("planner.summary.invernadero", "invernadero")
      : t("planner.summary.invernaderos", "invernaderos");
  const secLabel =
    blockCount === 1
      ? t("planner.summary.seccion", "sección")
      : t("planner.summary.secciones", "secciones");

  return (
    <div className="rounded-2xl bg-gradient-to-r from-teal-400 to-blue-500 text-white px-4 py-3 shadow-[0_10px_24px_-10px_rgba(56,178,172,0.55)] flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="shrink-0 w-9 h-9 rounded-xl bg-white/15 flex items-center justify-center">
          <MapPin className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold leading-tight truncate">
            {greenhouseCount} {ghLabel} · {blockCount} {secLabel}
          </div>
          <div className="text-[11px] text-white/80 leading-tight">
            {t("planner.summary.surfaceToTreat", "Superficie a tratar")}
          </div>
        </div>
      </div>
      <div className="shrink-0 text-right">
        <span className="text-2xl font-bold leading-none">
          {totalAreaHa.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
        <span className="text-sm font-medium ml-1">ha</span>
      </div>
    </div>
  );
}
